var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "confirm-line-haul-connection"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('br'), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading,
      "is-full-screen": ""
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('legend', [_vm._v("Bag Or Shipment Status Report")]), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3 radio"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedType),
      expression: "checkedType"
    }],
    attrs: {
      "type": "radio",
      "name": "bagNo",
      "id": "bagNo",
      "value": "bagNo"
    },
    domProps: {
      "checked": _vm._q(_vm.checkedType, "bagNo")
    },
    on: {
      "change": [function($event) {
        _vm.checkedType = "bagNo"
      }, _vm.checkField]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _c('label', {
    attrs: {
      "for": "bagNo"
    }
  }, [_vm._v("Bag No")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 radio"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedType),
      expression: "checkedType"
    }],
    attrs: {
      "type": "radio",
      "name": "shippingId",
      "id": "shippingId",
      "value": "shippingId"
    },
    domProps: {
      "checked": _vm._q(_vm.checkedType, "shippingId")
    },
    on: {
      "change": [function($event) {
        _vm.checkedType = "shippingId"
      }, _vm.checkField]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _c('label', {
    attrs: {
      "for": "shippingId"
    }
  }, [_vm._v("Shipping ID")])])], 1)])]), _vm._v(" "), _c('fieldset', [(_vm.checkedType == 'shippingId') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Hub Zone")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.listHubZoneData,
      "selected-option": _vm.listHubZoneObjDataFlt1,
      "name": "flthubzoneid",
      "placeholder": "Select Hub Zone"
    },
    on: {
      "select": _vm.selectedHubZoneFlt1
    },
    model: {
      value: (_vm.hubzoneidflt1),
      callback: function($$v) {
        _vm.hubzoneidflt1 = $$v
      },
      expression: "hubzoneidflt1"
    }
  })], 1), _vm._v(" "), (_vm.HubZoneErrorFlg) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.HubZoneErrorForFilter))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Source/Current Hub Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('Multiselect', {
    attrs: {
      "options": _vm.listSourceHubNameListForFilter,
      "name": "SourceHubName",
      "placeholder": " Source Hub Name",
      "track-by": "value",
      "label": "text"
    },
    on: {
      "select": _vm.selectedSourceHubName3
    },
    model: {
      value: (_vm.sourceHubIdArr),
      callback: function($$v) {
        _vm.sourceHubIdArr = $$v
      },
      expression: "sourceHubIdArr"
    }
  })], 1), _vm._v(" "), (_vm.sourceHubIdFlg) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.SourceHubErrorMsg))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Hub Zone")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.listHubZoneData,
      "selected-option": _vm.listHubZoneObjDataFlt2,
      "name": "flthubzoneid2",
      "placeholder": "Select Hub Zone"
    },
    on: {
      "select": _vm.selectedHubZoneFlt2
    },
    model: {
      value: (_vm.hubzoneidflt2),
      callback: function($$v) {
        _vm.hubzoneidflt2 = $$v
      },
      expression: "hubzoneidflt2"
    }
  })], 1), _vm._v(" "), (_vm.HubZoneErrorFlgForDest) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.HubZoneErrorForFilterForDest))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Destination Hub Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('Multiselect', {
    attrs: {
      "options": _vm.listDestHubNameListForFilter,
      "name": "DestinationHub",
      "placeholder": " Destination HubName",
      "track-by": "value",
      "label": "text"
    },
    on: {
      "select": _vm.selectedSourceHubName2
    },
    model: {
      value: (_vm.DesHubIDArr),
      callback: function($$v) {
        _vm.DesHubIDArr = $$v
      },
      expression: "DesHubIDArr"
    }
  })], 1), _vm._v(" "), (_vm.DesHubIDFlg) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.DesHubIDErrorMsg))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("From Date")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'error': _vm.errors.has('FromDate')
    },
    attrs: {
      "not-before": _vm.validDateRangeFrom,
      "not-after": _vm.todate ? _vm.todate : _vm.todaysDate,
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "name": "FromDate"
    },
    on: {
      "change": _vm.checkToDate
    },
    model: {
      value: (_vm.fromdate),
      callback: function($$v) {
        _vm.fromdate = $$v
      },
      expression: "fromdate"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "Black"
    }
  }, [_vm._v("Note:Date difference should be of 15 days")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.fromDateError))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("To Date")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'error': _vm.errors.has('ToDate')
    },
    attrs: {
      "not-before": _vm.fromdate,
      "not-after": _vm.validDateRange,
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "name": "ToDate"
    },
    on: {
      "change": _vm.checkFromDate
    },
    model: {
      value: (_vm.todate),
      callback: function($$v) {
        _vm.todate = $$v
      },
      expression: "todate"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.toDateError))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Shipping Id")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-archive'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingId),
      expression: "shippingId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Shipping Id",
      "name": "shippingId",
      "id": "shippingId"
    },
    domProps: {
      "value": (_vm.shippingId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.shippingIdError))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Shipment Status")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.shipmentStatusArray,
      "selected-option": _vm.selectedShipmentStatus,
      "name": "shipment status",
      "placeholder": "Select Status"
    },
    on: {
      "select": _vm.selectShipmentType
    },
    model: {
      value: (_vm.shipmentStatus),
      callback: function($$v) {
        _vm.shipmentStatus = $$v
      },
      expression: "shipmentStatus"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.shipmentStatusError))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Gap Hours")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-archive'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hours),
      expression: "hours"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Hours",
      "name": "hours",
      "id": "hours"
    },
    domProps: {
      "value": (_vm.hours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hours = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.hoursError))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Comprator")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.comparsionArray,
      "selected-option": _vm.selectedComprator,
      "name": "Comprator",
      "placeholder": "Select comprator"
    },
    on: {
      "select": _vm.selectcomprator
    },
    model: {
      value: (_vm.sign),
      callback: function($$v) {
        _vm.sign = $$v
      },
      expression: "sign"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.signError))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-form-fieldset', [_c('label', [_c('br')]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "common-success-btn",
    attrs: {
      "type": "submit",
      "size": "sm"
    },
    on: {
      "click": _vm.searchShipmentDetails
    }
  }, [_vm._v("Search")]), _vm._v(" \n                "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.checkField
    }
  }, [_vm._v("Reset")]), _vm._v(" \n                "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.getCsvDetailsForShipment
    }
  }, [_vm._v("Export")])])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.checkedType == 'bagNo') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Hub Zone")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.listHubZoneData,
      "selected-option": _vm.listHubZoneObjDataFlt1,
      "name": "flthubzoneid",
      "placeholder": "Select Hub Zone"
    },
    on: {
      "select": _vm.selectedHubZoneFlt1
    },
    model: {
      value: (_vm.hubzoneidflt1),
      callback: function($$v) {
        _vm.hubzoneidflt1 = $$v
      },
      expression: "hubzoneidflt1"
    }
  })], 1), _vm._v(" "), (_vm.HubZoneErrorFlg) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.HubZoneErrorForFilter))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Source/Current Hub Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('Multiselect', {
    attrs: {
      "options": _vm.listSourceHubNameListForFilter,
      "name": "SourceHubName",
      "placeholder": " Source Hub Name",
      "track-by": "value",
      "label": "text"
    },
    on: {
      "select": _vm.selectedSourceHubName3
    },
    model: {
      value: (_vm.sourceHubIdArr),
      callback: function($$v) {
        _vm.sourceHubIdArr = $$v
      },
      expression: "sourceHubIdArr"
    }
  })], 1), _vm._v(" "), (_vm.sourceHubIdFlg) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.SourceHubErrorMsg))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Hub Zone")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.listHubZoneData,
      "selected-option": _vm.listHubZoneObjDataFlt2,
      "name": "flthubzoneid2",
      "placeholder": "Select Hub Zone"
    },
    on: {
      "select": _vm.selectedHubZoneFlt2
    },
    model: {
      value: (_vm.hubzoneidflt2),
      callback: function($$v) {
        _vm.hubzoneidflt2 = $$v
      },
      expression: "hubzoneidflt2"
    }
  })], 1), _vm._v(" "), (_vm.HubZoneErrorFlgForDest) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.HubZoneErrorForFilterForDest))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Destination Hub Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('Multiselect', {
    attrs: {
      "options": _vm.listDestHubNameListForFilter,
      "name": "DestinationHub",
      "placeholder": " Destination HubName",
      "track-by": "value",
      "label": "text"
    },
    on: {
      "select": _vm.selectedSourceHubName2
    },
    model: {
      value: (_vm.DesHubIDArr),
      callback: function($$v) {
        _vm.DesHubIDArr = $$v
      },
      expression: "DesHubIDArr"
    }
  })], 1), _vm._v(" "), (_vm.DesHubIDFlg) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.DesHubIDErrorMsg))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("From Date")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'error': _vm.errors.has('FromDate')
    },
    attrs: {
      "not-before": _vm.validDateRangeFrom,
      "not-after": _vm.todate ? _vm.todate : _vm.todaysDate,
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "name": "FromDate"
    },
    on: {
      "change": _vm.checkToDate
    },
    model: {
      value: (_vm.fromdate),
      callback: function($$v) {
        _vm.fromdate = $$v
      },
      expression: "fromdate"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "Black"
    }
  }, [_vm._v("Note:Date difference should be of 15 days")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.fromDateError))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("To Date")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'error': _vm.errors.has('ToDate')
    },
    attrs: {
      "not-before": _vm.fromdate,
      "not-after": _vm.validDateRange,
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "name": "ToDate"
    },
    on: {
      "change": _vm.checkFromDate
    },
    model: {
      value: (_vm.todate),
      callback: function($$v) {
        _vm.todate = $$v
      },
      expression: "todate"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.toDateError))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Bag No")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-archive'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bagNo),
      expression: "bagNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Bag No",
      "name": "bagNo",
      "id": "bagNo"
    },
    domProps: {
      "value": (_vm.bagNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bagNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.bagNoError))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Bag Status")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.bagStatusArray,
      "selected-option": _vm.selectedbagStatus,
      "name": "Bag status",
      "placeholder": "Select Bag Status"
    },
    on: {
      "select": _vm.selectBagStatus
    },
    model: {
      value: (_vm.bagStatus),
      callback: function($$v) {
        _vm.bagStatus = $$v
      },
      expression: "bagStatus"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.bagStausError))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Gap Hours")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-archive'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hours),
      expression: "hours"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Hours",
      "name": "hours",
      "id": "hours"
    },
    domProps: {
      "value": (_vm.hours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hours = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.hoursError))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Comprator")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.comparsionArray,
      "selected-option": _vm.selectedComprator,
      "name": "Comprator",
      "placeholder": "Select comprator"
    },
    on: {
      "select": _vm.selectcomprator
    },
    model: {
      value: (_vm.sign),
      callback: function($$v) {
        _vm.sign = $$v
      },
      expression: "sign"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.signError))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-form-fieldset', [_c('label', [_c('br')]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "common-success-btn",
    attrs: {
      "type": "submit",
      "size": "sm"
    },
    on: {
      "click": _vm.searchBagDetails
    }
  }, [_vm._v("Search")]), _vm._v(" \n                "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.checkField
    }
  }, [_vm._v("Reset")]), _vm._v(" \n                "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.getCsvDetailsForBag
    }
  }, [_vm._v("Export")])])], 1)], 1)]) : _vm._e()])])], 1)]), _vm._v(" "), (_vm.showBagTable == true) ? _c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_c('b', [_vm._v("Total Bags:- " + _vm._s(_vm.totalBags))])]), _vm._v(" "), _c('b-card', [_c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("OriginHub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Destination Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Current Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("CB Bag")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Total Child Bags")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Total Shipments")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shortage Shipments")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Overage Shipments")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Volumetric Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Physical Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Chargeable Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Last Modified Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Last Modified By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Pending Hours")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Route Mode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Created By")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.bagDetails), function(data, index) {
    return (_vm.bagDetails.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.originhubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.destinationhubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.currenthubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagtype))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.cbbag))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.totalchildbags))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.totalshipments))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shortageshipments))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.overageshipments))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.volumetricweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.physicalweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.chargeableweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.lastmodifieddate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.lastmodifiedby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.pendinghrs))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.routemode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagcreateddate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagcreatedby))])]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalRows > 10),
      expression: "totalRows>10"
    }],
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.showShipmentTable == true) ? _c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_c('b', [_vm._v("Total Shipments:- " + _vm._s(_vm.totalShipments))])]), _vm._v(" "), _c('b-card', [_c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipment Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("User Process")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Origin Hub ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Current Hub ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Final Destination ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("LastModified By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("LastModified Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Pending Days")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.shipmentDetails), function(data, index) {
    return (_vm.shipmentDetails.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ShippingID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.Status))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ShipmentStatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.UserProcess))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.OriginHubName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.CurrentLocationName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.FinalDestinationName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.CreatedDate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.LastModifiedBy))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.LastModifiedDate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.PendingDays))])]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalRows > 10),
      expression: "totalRows>10"
    }],
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationDataForShipment,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)])], 1) : _vm._e()])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22b130a0","hasScoped":true}!./src/views/components/bagAndShipmentStatusReport/bagAndShipmentStatusReport.html
// module id = 1297
// module chunks = 2